import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useCallback, useEffect, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import { useParams } from "react-router-dom";

const DonationDetailByLoginId = () => {
    const [error, setError] = useState();
    const [donationDataByLoginId, setDonationDataByLoginIdByLoginId] = useState([]);
    const params = useParams();
    const LoginId = params?.id;

    const fetchdonationDataByLoginId = useCallback(async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getDonationDetailByLoginId}/${LoginId}`);
            if (response.status === 200) {
                setDonationDataByLoginIdByLoginId(response?.data?.data)
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        }
    }, [LoginId]);

    useEffect(() => {
        fetchdonationDataByLoginId();
    }, [fetchdonationDataByLoginId]);


    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex" style={{ gap: "20px" }}>
                        <span onClick={() => window.history.back()} className="back-link" title="back">
                            <i className="fa fa-arrow-left"></i>
                        </span>
                        <h4 className="mb-0">Donation Detail of {donationDataByLoginId[0]?.Name}</h4>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="row">
                        {donationDataByLoginId && donationDataByLoginId.length > 0 ? (
                            donationDataByLoginId.map((donation, index) => (
                                <div className="col-md-3" key={index}>
                                    <div key={index} className="booking_warp_box  mt-4">
                                        <div className="card-body">
                                            <h5 className="card-title mb-2">{donation?.Name}</h5>
                                            <p className="card-text"><strong>Email:</strong> {donation?.Email}</p>
                                            <p className="card-text"><strong>PAN:</strong> {donation?.PAN}</p>
                                            <p className="card-text"><strong>Address:</strong> {donation?.Address}</p>
                                            <p className="card-text"><strong>Amount:</strong> {donation?.Amount}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No booking data available.</p>
                        )}
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default DonationDetailByLoginId;